document.addEventListener('DOMContentLoaded', function() {
    const body = document.body;
    body.classList.add('ready');

    // show-nav toggle
    const toggleNav = document.getElementById('toggle-nav');
    let navScrollPosition = 0;

    function openNav() {
        navScrollPosition = window.scrollY;
        body.style.top = `-${navScrollPosition}px`;
        body.classList.add('show-nav');
    }

    function closeNav() {
        body.classList.remove('show-nav');
        body.style.top = '';
        window.scrollTo(0, navScrollPosition);
    }

    if (toggleNav) {
        toggleNav.addEventListener('click', function() {
            if (body.classList.contains('show-nav')) {
                closeNav();
            } else {
                openNav();
            }
        });
    }

    // Close nav on ESC key
    document.addEventListener('keydown', function(e) {
        if ((e.key === 'Escape' || e.keyCode === 27) && body.classList.contains('show-nav')) {
            closeNav();
        }
    });

    // Nav scroll js
    const navbar = document.querySelector("#branding"); // Change this to your navbar's class or ID
    if (navbar) {
        window.addEventListener("scroll", function () {
            if (window.scrollY > 30) { // Change 50 to whatever threshold you want
                navbar.classList.add("scrolled");
            } else {
                navbar.classList.remove("scrolled");
            }
        });
    }

    // Initialize Swiper if banner exists
    const bannerSwiper = document.querySelector('.swiper');
    if (bannerSwiper) {
        const swiper = new Swiper('.swiper', {
            // Optional parameters
            loop: true,
            effect: 'fade',
            speed: 1000,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            
            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            
            // Pagination
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        });
    }
});